<template>
    <BannerAbstract class="banner-trial">

        <template #title>
            Limited Trial
        </template>
        <template #message>
            You are using a limited trial version. Select a subscription plan to use all features.
        </template>
        <template #actions>
            <v-btn 
                elevation="0" 
                @click="handleSelect">
                Select Plan
            </v-btn>
        </template>

    </BannerAbstract>
</template>

<script>
import ROUTES from '@generio-ai/library-legacy/constants/routes'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import BannerAbstract from '@/components/common/banner/BannerAbstract.vue'

export default {
    name: 'BannerTrial',
    components: {
        BannerAbstract
    },
    methods: {
        ...mapActions('router', [
            'openRoute'
        ]),
        handleSelect()
        {
            this.openRoute({ route: ROUTES.ACCOUNT.SUBSCRIPTION })
        }
    }
}
</script>

<style>
.banner-trial .v-btn {
    color: rgb(var(--v-theme-primary));
}

.banner-trial .v-btn:hover {
    background-color: rgba(var(--v-theme-error), 0.5);
}
</style>

<style scoped>
.banner-trial {
    /*background-color: rgba(var(--v-theme-error), 0.2);*/
    background: linear-gradient(180deg, rgba(var(--v-theme-error), 0.5), rgba(var(--v-theme-error), 0.3));
}
</style>